// Componentes de loading específicos para autenticação
"use client";

import FormLoading from "./FormLoading";

export function SSOLoading() {
  return (
    <FormLoading
      title="Autenticação SSO"
      message="Estamos conectando você via SSO do GSI. Isso pode levar alguns instantes."
      type="circular"
    />
  );
}

export function GovBRLoading() {
  return (
    <FormLoading
      title="Autenticação GovBR"
      message="Processando sua autenticação com GovBR. Aguarde enquanto validamos suas credenciais."
      type="linear"
    />
  );
}

export function GSILoading() {
  return (
    <FormLoading
      title="Autenticação GSI"
      message="Verificando suas credenciais no sistema. Por favor, aguarde."
      type="circular"
    />
  );
}

export function InitialLoading() {
  return (
    <FormLoading
      title="Carregando..."
      message="Preparando o ambiente de autenticação."
      type="linear"
    />
  );
}
